import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AutoconsumoMotivoPedidoService} from "../../../../services/autoconsumo-motivo-pedido.service";
import {DatosMaestrosService} from "../../../../../../services/datos-maestros.service";
import {UtilsService} from "../../../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {forkJoin, Subscription} from "rxjs";
import {moduloAutoconsumo} from "../../../../diccionarios/autoconsumoModulo";
import {AutoconsumoCreacionMantenedorService} from "../../../../services/autoconsumo-creacion-mantenedor.service";
import {MantenedorSolicitudPedidoVentaService} from "../../../../services/mantenedor-solicitud-pedido-venta.service";
import {Client} from "../../../../../portfolio/interfaces/client.interface";
import * as _ from 'lodash';
import {Router} from "@angular/router";

@Component({
  selector: 'app-solicitud-pedido-venta-autoconsumo',
  templateUrl: './solicitud-pedido-venta-autoconsumo.component.html',
  styleUrls: ['./solicitud-pedido-venta-autoconsumo.component.css']
})
export class SolicitudPedidoVentaAutoconsumoComponent implements OnInit, OnDestroy {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbOrganizacionVenta: any[];
  cmbCanalVenta: any[];
  cmbSectorVenta: any[];
  cmbGrupoVendedor: any[];
  cmbCondicionPago: any[];
  cmbClasePedido: any[];
  cmbOficinaVenta: any[];
  cmbGerencias: any[];
  cmbCondicionExpedicion: any[];
  cmbCentroLogistico: any[];
  cmbAlmacen: any[];
  cmbMotivoPedido: any[];
  cmbCuentaContable: any[];
  cmbAutoconsumoMotivoPedido: any[];
  cmbParametroCliente: any[];
  cmbParametroClienteOriginal: any[];
  rowSelection: any;
  gridApi: any;
  subscription1$: Subscription;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  @Input() solicitudData: any;
  lineaDetalleArray: any[];
  editClient: boolean = false;
  validateEditClient: boolean = false;
  subscription2$: Subscription;
  clienteSelectedItem;


  constructor(
    private fb: FormBuilder,
    private _autoconsumoMotivoPedidoService: AutoconsumoMotivoPedidoService,
    private _autoconsumoCreacionMantenedorService: AutoconsumoCreacionMantenedorService,
    private _mantenedorSolicitudPedidoVentaService: MantenedorSolicitudPedidoVentaService,
    private _datosMaestrosService: DatosMaestrosService,
    private _util: UtilsService,
    private router: Router,
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }

  ngOnDestroy(): void {
    this.subscription1$ && this.subscription1$.unsubscribe();
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_TITULOS = moduloAutoconsumo.titulos.autoconsumoMotivoPedido;
    this.DAT_BTNCSS = moduloAutoconsumo.button.buttonsCss;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.textBoton = moduloAutoconsumo.button.buttonsNombre.agregar;
    this.titulo = this.DAT_TITULOS.titulo;
    this.formulario = this.fb.group({
      idPedido: [null], //LISTO
      idMotivoPedido: ['', [Validators.required]], //LISTO
      ctactble: ['', [Validators.required]], //LISTO
      ctactbleDesc: ['', [Validators.required]], //LISTO
      idCliente: ['', [Validators.required]],  //LISTO
      nombreCliente: ['', [Validators.required]],  //LISTO
      idOrgaVenta: ['', [Validators.required]], //LISTO
      idCanalVenta: ['', [Validators.required]], //LISTO
      idSectorVenta: ['', [Validators.required]], //LISTO
      estado: [''], //LISTO
      fechaPedido: ['', [Validators.required]], //LISTO
      idDivisa: ['', [Validators.required]], //LISTO
      idGrupoVendedor: ['', [Validators.required]], //LISTO
      descGrupoVendedor: ['',], //LISTO
      idGrupoCliente: [''], //LISTO
      idCondPago: ['', [Validators.required]], //LISTO
      descCondPago: ['',], //LISTO
      idClasePedido: ['', [Validators.required]],//LISTO
      idOficinaVenta: ['', [Validators.required]],//LISTO
      idCond: ['', [Validators.required]],//LISTO
      idCentro: ['', [Validators.required]],//LISTO
      idAlmacen: ['', [Validators.required]],
      codGerencia: ['', [Validators.required]],

      lsPedidoDetalle: [[]],
      ordenVenta: [''],
      //nombreCliente1: ['', [Validators.required]],  //LISTO
    });
    this.getFormInfo();
    this.girdComponent();
    this.getAllGerencias();
    //console.log(this.solicitudData);
    this.subscription1$ = this._mantenedorSolicitudPedidoVentaService.lineaDetalleListener().subscribe(data => {
      //console.log('lineaDetalleListener', data);
      if (data.action === 'nuevo' || data.action === 'editar') {
        this.rowData = data.result;
        this.lineaDetalleArray = data.result;
      }
      this.mostrarGridLista = true;
    });
    this.subscription2$ = this._mantenedorSolicitudPedidoVentaService.clienteSelectedListener().subscribe(data => {
      //console.log(data);
      this.clienteSelected(data);
    });
    this.formulario.get('idCliente').valueChanges.subscribe(() => this.onFormChange());
    this.formulario.get('nombreCliente').valueChanges.subscribe(() => this.onFormChange());
    this.formulario.get('idOrgaVenta').valueChanges.subscribe(() => this.onFormChange());
    this.formulario.get('idCanalVenta').valueChanges.subscribe(() => this.onFormChange());
    this.formulario.get('idSectorVenta').valueChanges.subscribe(() => this.onFormChange());
  }

  formatInitInformation(solicitudData, validateEditClient?) {
    if (solicitudData && solicitudData.accion && solicitudData.accion === 'nuevo') {
      this.formulario.get('fechaPedido').setValue(this.obtenerFechaActual());
      this.formulario.get('estado').setValue('CREADO');
      this.formulario.get('idDivisa').setValue('USDN');
      if (solicitudData && solicitudData.idPedido) {
        this.formulario.get('idPedido').setValue(solicitudData.idPedido);
      }
      if (this.cmbParametroCliente && this.cmbParametroCliente.length > 0) {
        this.formulario.get('idCliente').setValue(this.cmbParametroCliente[0].id);
        this.changeCliente(validateEditClient);
      }
    } else {
      this.formulario.get('idPedido').setValue(solicitudData.data.idPedido);
      this.formulario.get('idMotivoPedido').setValue(solicitudData.data.idMotivoPedido);
      this.formulario.get('ctactble').setValue(solicitudData.data.ctactble);
      this.formulario.get('ctactbleDesc').setValue(solicitudData.data.ctactbleDesc);
      this.formulario.get('idCliente').setValue(solicitudData.data.idCliente);
      this.formulario.get('nombreCliente').setValue(solicitudData.data.nombreCliente1);
      this.formulario.get('idOrgaVenta').setValue(solicitudData.data.idOrgaVenta);
      this.formulario.get('idCanalVenta').setValue(solicitudData.data.idCanalVenta);
      this.formulario.get('idSectorVenta').setValue(solicitudData.data.idSectorVenta);
      this.formulario.get('estado').setValue(solicitudData.data.estado);
      this.formulario.get('fechaPedido').setValue(solicitudData.data.fechaPedido);
      this.formulario.get('idDivisa').setValue(solicitudData.data.idDivisa);
      this.formulario.get('idGrupoVendedor').setValue(solicitudData.data.idGrupoVendedor);
      this.formulario.get('idCondPago').setValue(solicitudData.data.idCondPago);
      this.formulario.get('idClasePedido').setValue(solicitudData.data.idClasePedido);
      this.formulario.get('idOficinaVenta').setValue(solicitudData.data.idOficinaVenta);
      this.formulario.get('idCond').setValue(solicitudData.data.idCond);
      this.formulario.get('idCentro').setValue(solicitudData.data.idCentro);
      this.formulario.get('idAlmacen').setValue(solicitudData.data.idAlmacen);
      this.formulario.get('lsPedidoDetalle').setValue(solicitudData.data.lsPedidoDetalle);
      this.formulario.get('ordenVenta').setValue(solicitudData.data.ordenVenta);
      this.formulario.get('codGerencia').setValue(solicitudData.data.codGerencia);
      this.changeCentro();
      this.changeMotivoPedido();
      this.initGrupoVentaAndCondicionPago();
    }

    this.lineaDetalleArray = this.formulario.get('lsPedidoDetalle').value;
    solicitudData.lineaDetalleArray = this.formulario.get('lsPedidoDetalle').value;
    this.rowData = this.lineaDetalleArray;
  }


  obtenerFechaActual() {
    const fechaActual = new Date();
    const anio = fechaActual.getFullYear();
    const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
    const dia = fechaActual.getDate().toString().padStart(2, '0');
    const hora = fechaActual.getHours().toString().padStart(2, '0');
    const minutos = fechaActual.getMinutes().toString().padStart(2, '0');
    const segundos = fechaActual.getSeconds().toString().padStart(2, '0');

    const fechaOracleFormat = `${anio}-${mes}-${dia}T${hora}:${minutos}:${segundos}`;
    return fechaOracleFormat;
  }


  getAlmacenByCentro(data) {
    this.loading = true;
    this._datosMaestrosService.getAllAlmacenByCentro(data).subscribe((res: any) => {
      res.map(almacen => {
        almacen.id = almacen.idAlmacen;
        almacen.descripcion = almacen.idAlmacen + ' | ' + almacen.dscaAlmacen;
      });
      this.cmbAlmacen = res.sort((a, b) => a.idAlmacen.localeCompare(b.idAlmacen));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbAlmacen = [];
      this._util.mensajeErroToast('Problemas al intentar cargar Almacenes.', 3000);
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'LINEA',
        field: 'posicion',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'MATERIAL',
        field: 'idMaterial',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DESCRIPCION',
        field: 'dscaMaterial',
        sortable: true,
        filter: true,
        width: 400
      },
      {
        headerName: 'UNIDAD',
        field: 'idUnidad',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'CANTIDAD',
        field: 'cantidad',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'PRECIO',
        field: 'precio',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'IMPORTE',
        field: 'importe',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarLineaDetalle.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarLineaDetalle({rowData}) {
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.solicitudData.lineaDetalleEvent = 'editar';
    this.solicitudData.lineaDetalleArray = this.lineaDetalleArray;
    this.solicitudData.data = rowData;
  }

  eliminar({rowData}) {
    this.rowData = this.eliminarObjetoYActualizarIndex(this.rowData, rowData);
    this.lineaDetalleArray = this.rowData;
    this.solicitudData.lineaDetalleArray = this.lineaDetalleArray;
    //console.log(this.rowData);
  }

  eliminarObjetoYActualizarIndex(arr: any[], objToDelete: any): any[] {
    const newArray = arr.filter((item) => item !== objToDelete);
    const updatedArray = newArray.map((item, index) => ({
      ...item,
      posicion: index + 1,
    }));
    return updatedArray;
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.solicitudData.lineaDetalleEvent = 'nuevo';
    this.solicitudData.lineaDetalleArray = this.lineaDetalleArray;
    this.solicitudData.formularioSolicitudPedidoVenta = this.formulario.value;
  }

  getFormInfo() {
    this.loading = true;
    const _getAllAutoconsumoMotivoPedido = this._autoconsumoMotivoPedidoService.getAllMotivoPedido();
    const _getAllAutoconsumoClientes = this._autoconsumoCreacionMantenedorService.getAll();
    const _getAllOrganizacionVenta = this._datosMaestrosService.getAllOrganizacionVenta();
    const _getAllCanalVenta = this._datosMaestrosService.getAllCanalVenta();
    const _getAllSectorVenta = this._datosMaestrosService.getAllSectorVenta();
    //const _getAllGrupoVendedor = this._datosMaestrosService.getAllGrupoVendedor();
    //const _getAllCondicionPago = this._datosMaestrosService.getAllSimpleCondicionPago();
    const _getAllClasePedido = this._datosMaestrosService.getAllOnlyClasePedido();
    const _getAllOficinasVentas = this._datosMaestrosService.getAllOficinasVentas();
    const _getAllCondicionExpedicion = this._datosMaestrosService.getAllCondicionExpedicion();
    const _getAllCentros = this._datosMaestrosService.getAllCentroLogistico();
    const _getAllGerencia = this._mantenedorSolicitudPedidoVentaService.obtenerListaGerencia();

    forkJoin([_getAllAutoconsumoMotivoPedido, _getAllAutoconsumoClientes, _getAllOrganizacionVenta,
      _getAllCanalVenta, _getAllSectorVenta, _getAllClasePedido, _getAllOficinasVentas,
      _getAllCondicionExpedicion, _getAllCentros, _getAllGerencia]).subscribe((res: any) => {
      res[0].map(autoconsumoMotivoPedido => {
        autoconsumoMotivoPedido.descripcionMotivoPedido = autoconsumoMotivoPedido.idMotivoPedido + ' | ' + autoconsumoMotivoPedido.dscaMotivoPedido;
        autoconsumoMotivoPedido.descripcionCuentaContable = autoconsumoMotivoPedido.ctaContable + ' | ' + autoconsumoMotivoPedido.dscaCuentaContable;
        autoconsumoMotivoPedido.id = autoconsumoMotivoPedido.idMotivoPedido;
        autoconsumoMotivoPedido.descripcion = autoconsumoMotivoPedido.descripcionMotivoPedido;
      });
      res[1].respuesta.map(parametroCliente => {
        parametroCliente.id = parametroCliente.cliente.idCliente;
        parametroCliente.descripcion = parametroCliente.id + ' | ' + parametroCliente.cliente.nombreCliente1;
      });
      res[2].map(organizacionVenta => {
        organizacionVenta.id = organizacionVenta.idOrgaVenta;
        organizacionVenta.descripcion = organizacionVenta.idOrgaVenta + ' | ' + organizacionVenta.dscaOrgaVenta;
      });
      res[3].map(canalVenta => {
        canalVenta.id = canalVenta.idCanalVenta;
        canalVenta.descripcion = canalVenta.idCanalVenta + ' | ' + canalVenta.dscaCanalVenta;
      });
      res[4].map(sectorVenta => {
        sectorVenta.id = sectorVenta.idSectorVenta;
        sectorVenta.descripcion = sectorVenta.idSectorVenta + ' | ' + sectorVenta.dscaSectorVenta;
      });
      res[5].map(clasePedido => {
        clasePedido.id = clasePedido.idClasePedido;
        clasePedido.descripcion = clasePedido.idClasePedido + ' | ' + clasePedido.descripcionClasePedido;
      });
      res[6].map(oficinaVenta => {
        oficinaVenta.id = oficinaVenta.idOficinaVenta;
        oficinaVenta.descripcion = oficinaVenta.idOficinaVenta + ' | ' + oficinaVenta.dscaOficinaVenta;
      });
      res[7].map(condicionExpedicion => {
        condicionExpedicion.id = condicionExpedicion.idCond;
        condicionExpedicion.descripcion = condicionExpedicion.idCond + ' | ' + condicionExpedicion.descCorta;
      });
      res[8].map(centroLogistico => {
        centroLogistico.id = centroLogistico.idCentro;
        centroLogistico.descripcion = centroLogistico.idCentro + ' | ' + centroLogistico.nombreCentro;
      });
      //console.log(res[0]);

      this.cmbAutoconsumoMotivoPedido = res[0].sort((a, b) => a.idMotivoPedido.localeCompare(b.idMotivoPedido));
      this.cmbParametroCliente = res[1].respuesta;
      console.log(this.cmbParametroCliente);
      this.cmbOrganizacionVenta = res[2].sort((a, b) => a.idOrgaVenta.localeCompare(b.idOrgaVenta));
      this.cmbCanalVenta = res[3].sort((a, b) => a.idCanalVenta.localeCompare(b.idCanalVenta));
      this.cmbSectorVenta = res[4].sort((a, b) => a.idSectorVenta.localeCompare(b.idSectorVenta));
      this.cmbClasePedido = res[5].sort((a, b) => a.idClasePedido.localeCompare(b.idClasePedido));
      this.formulario.get('idClasePedido').setValue("ZO02");
      this.cmbOficinaVenta = res[6].sort((a, b) => a.idOficinaVenta.localeCompare(b.idOficinaVenta));
      this.cmbCondicionExpedicion = res[7].sort((a, b) => a.idCond.localeCompare(b.idCond));
      this.formulario.get('idCond').setValue("Z2");
      this.cmbCentroLogistico = res[8].sort((a, b) => a.idCentro.localeCompare(b.idCentro));
      this.loading = false;
      this.formatInitInformation(this.solicitudData);
    }, () => {
      this.loading = false;
      this.cmbAutoconsumoMotivoPedido = [];
      this.cmbParametroCliente = [];
      this.cmbOrganizacionVenta = [];
      this.cmbCanalVenta = [];
      this.cmbSectorVenta = [];
      this.cmbClasePedido = [];
      this.cmbOficinaVenta = [];
      this.cmbCondicionExpedicion = [];
      this.cmbCentroLogistico = [];
      this.formatInitInformation(this.solicitudData);
      this._util.mensajeErroToast('Problemas al intentar cargar la información requerida por el formulario', 5000);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        this.agregar();
      }
    } else {
      this.regresar();
    }
  }

  agregar() {
    //console.log('prueba Alfredo');
    this.formulario.get('lsPedidoDetalle').setValue(this.lineaDetalleArray);
    if (this.solicitudData && this.solicitudData.accion && this.solicitudData.accion === 'nuevo') {
      //this.solicitudData.lsPedidoDetalle.push(this.formulario.value);
      this._mantenedorSolicitudPedidoVentaService.solicitudVentaEvent({
        action: 'nuevo',
        result: this.formulario.value
      });
    } else if (this.solicitudData && this.solicitudData.accion && this.solicitudData.accion === 'editar') {
      /*      const newArrayLineaDetalle = this.solicitudData.lineaDetalleArray.map((item) =>
              item.posicion === this.formulario.get('posicion').value ? this.formulario.value : item
            );*/
      this._mantenedorSolicitudPedidoVentaService.lineaDetalleEvent({
        action: 'editar',
        result: this.formulario.value
      });
    }
    this.formulario.reset();
  }


  regresar() {
    //console.log('prueba Alfredo');
    this.formulario.reset();
    this.lineaDetalleArray = [];
    this._mantenedorSolicitudPedidoVentaService.solicitudVentaEvent({
      action: 'regresar',
      result: ''
    });
  }


  changeMotivoPedido() {
    if (this.formulario && this.formulario.get('idMotivoPedido') && this.formulario.get('idMotivoPedido').value && this.formulario.get('idMotivoPedido').value != '') {
      const selectedMotivoPedido = this.cmbAutoconsumoMotivoPedido.find(data => data.id === this.formulario.get('idMotivoPedido').value);
      this.formulario.get('ctactble').setValue(selectedMotivoPedido.ctaContable);
      this.formulario.get('ctactbleDesc').setValue(selectedMotivoPedido.descripcionCuentaContable);
      //console.log(this.formulario.value);
    }
  }

  changeCliente(validateEditClient?) {
    if (this.formulario && this.formulario.get('idCliente') && this.formulario.get('idCliente').value && this.formulario.get('idCliente').value != '') {
      const selectedCliente = this.cmbParametroCliente.find(data => data.id === this.formulario.get('idCliente').value);
      this.formulario.get('nombreCliente').setValue(selectedCliente.cliente.nombreCliente1);
      this.formulario.get('idOrgaVenta').setValue(selectedCliente.idOrgaVenta);
      this.formulario.get('idCanalVenta').setValue(selectedCliente.idCanalVenta);
      this.formulario.get('idSectorVenta').setValue(selectedCliente.idSectorVenta);
      this.initGrupoVentaAndCondicionPago(validateEditClient);
      //console.log(this.formulario.value);
    }
  }

  initGrupoVentaAndCondicionPago(validateEditClient?) {
    if (this.formulario && this.formulario.get('idCliente') && this.formulario.get('idCliente').value && this.formulario.get('idCliente').value != '') {
      this.loading = true;
      const payload = {
        data: {
          idCliente: this.formulario.get('idCliente').value,
          idOrgaVenta: this.formulario.get('idOrgaVenta').value,
          idCanalVenta: this.formulario.get('idCanalVenta').value,
          idSectorVenta: this.formulario.get('idSectorVenta').value,
        }
      }
      this._datosMaestrosService.getClienteVentaAmpliadoPorPKClientePKOrgaVentaPKCanalVentaPKSectorVenta(payload).subscribe(data => {
        //console.log('info para grupo de venta y para condicion de pago', data);
        if (data && data.length > 0) {
          this.formulario.get('descGrupoVendedor').setValue(data[0].grupoVendedor.idGrupoVendedor + ' | ' + data[0].grupoVendedor.dscaGrupoVendedor);
          this.formulario.get('descCondPago').setValue(data[0].condicionPago.id_cond_pago + ' | ' + data[0].condicionPago.dsca_cond_pago);
          this.formulario.get('idGrupoVendedor').setValue(data[0].grupoVendedor.idGrupoVendedor);
          this.formulario.get('idGrupoCliente').setValue(data[0].grupoCliente.idGrupoCliente);
          this.formulario.get('idCondPago').setValue(data[0].condicionPago.id_cond_pago);
        }
        if (validateEditClient) {
          this.validateEditClient = true;
        }
        this.loading = false;
      }, () => {
        this._util.mensajeErroToast('Problemas al intentar cargar la información requerida por el formulario', 5000);
        this.loading = false;
      });
      //console.log(this.formulario.value);
    }
  }

  solicitarAprobacion() {
    this._util.confirmarSincronoPromesaSinActions(
      {
        title: this.DAT_MSG.solicitarAprobacion,
        text: ``,
        action: this.DAT_BTNS.aprobar,
      }
    ).then((res: any) => {
      this.formulario.get('estado').setValue('CONFIRMADO');
      let payload = {
        action: 'editar',
        result: this.formulario.value
      };
      this._mantenedorSolicitudPedidoVentaService.solicitudVentaEvent(payload);
      this.formulario.reset();
    });
  }

  changeCentro() {
    if (this.formulario && this.formulario.get('idCentro') && this.formulario.get('idCentro').value && this.formulario.get('idCentro').value != '') {
      this.getAlmacenByCentro(this.formulario.get('idCentro').value);
    }
  }

  getAllGerencias() {
    this.loading = true;
    this._mantenedorSolicitudPedidoVentaService.obtenerListaGerencia().subscribe((res: any) => {
      console.log(res.respuesta);
      this.cmbGerencias = res.respuesta;
    }, () => {
      this.loading = false;
      this.cmbGerencias = [];
      this._util.mensajeErrorVisto("Configuracion Gerencias", true, 9000, "Su usuario no esta configurado con Gerencias (portal-compras/Administracion), contacte con el administrador de Autoconsumo");
      //this._util.mensajeErroToast('Problemas al intentar cargar las Gerencias para este usuario.', 3000);
      setTimeout(() => {
        this.router.navigate(['../']);
      }, 3000);
    });
    this.loading = false;
  }

  validateEditClientMethod() {
    let payload = {
      idCanalVenta: this.formulario.get('idCanalVenta').value,
      idCliente: this.formulario.get('idCliente').value,
      idOrgaVenta: this.formulario.get('idOrgaVenta').value,
      idSectorVenta: this.formulario.get('idSectorVenta').value
    };
    this.loading = true;
    this._autoconsumoCreacionMantenedorService.validarCliente(payload).subscribe((res: any) => {
      //console.log(res.mensaje);
      this.validateEditClient = true;
      let newItem = [
        {
          cliente: this.clienteSelectedItem,
          descripcion: this.formulario.get('idCliente').value + ' | ' + this.formulario.get('nombreCliente').value,
          id: this.formulario.get('idCliente').value,
          idCanalVenta: this.formulario.get('idCanalVenta').value,
          idCliente: this.formulario.get('idCliente').value,
          idOrgaVenta: this.formulario.get('idOrgaVenta').value,
          idSectorVenta: this.formulario.get('idSectorVenta').value
        }
      ]
      this.cmbParametroCliente = newItem;
      this.loading = false;
      this.formatInitInformation(this.solicitudData, this.validateEditClient);
      this.validateEditClient = true;
    }, () => {
      this.loading = false;
      this._util.mensajeErroToast('Problemas al intentar validar la inforcacion del nuevo cliente', 3000);
    });
  }

  editClientMethod() {
    if (this.editClient) {
      if (!this.cmbParametroClienteOriginal || this.cmbParametroClienteOriginal.length === 0) {
        this.cmbParametroClienteOriginal = _.cloneDeep(this.cmbParametroCliente);
      }
    } else {
      this.cmbParametroCliente = _.cloneDeep(this.cmbParametroClienteOriginal);
      this.formatInitInformation(this.solicitudData);
    }
    this.validateEditClient = false;
  }

  onFormChange() {
    this.validateEditClient = false;
  }

  clienteSelected(cliente: Client) {
    console.log(cliente);
    this.clienteSelectedItem = cliente;
    this.formulario.get('idCliente').setValue(cliente.idCliente);
    this.formulario.get('nombreCliente').setValue(cliente.nombreCliente1);
  }
}
